import Contact_Entity from "./contact";
import "react";
export default class Contact extends Contact_Entity {
  static fromList(contactsJSON: unknown): Array<Contact> {
    const contacts: Contact[] = [];
    if (contactsJSON)
      Array.isArray(contactsJSON) &&
        contactsJSON.forEach((contactJSON) => {
          contacts.push(new Contact(contactJSON));
        });
    return contacts;
  }

  toJson(): string {
    return JSON.stringify(this);
  }

  static empty() {
    return new Contact({
      id: 0,
      memberID: 0,
      category: "",
      createdAt: "",
      updatedAt: "",
    });
  }

  format() {
    switch (this.category) {
      case "ADDRESS":
        return (
          <>
            {this.street}
            <br />
            {this.zipcode} {this.city}
            <br />
            {this.state}, {this.country}
          </>
        );
      case "EMAIL":
        return `${this.email}`;
      case "PHONE":
        return `${this.phone}`;
      case "LINK":
        return `${this.email}`;
      default:
        return "";
    }
  }

  categoryIcon() {
    switch (this.category) {
      case "ADDRESS":
        return "fa-solid fa-house";
      case "EMAIL":
        return "fa-solid fa-at";
      case "PHONE":
        return "fa-solid fa-phone";
      case "LINK":
        return "fa-solid fa-paperclip";
      default:
        return "fa-solid fa-house";
    }
  }

  getLabel() {
    return this.label ?? "Untitled";
  }
}
